module.exports = __webpack_public_path__ + "img/duix.f631d89a.png";